import type { LucideIcon } from "lucide-react";

/** Matches the reference prototype's numbered section header (".step-num" + ".section-label"). */
export function StepLabel({ step, children }: { step: number; children: React.ReactNode }) {
  return (
    <div className="flex items-center text-[13px] font-extrabold mb-3">
      <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-brand-blue text-white text-[11px] font-extrabold mr-1.5 flex-shrink-0">
        {step}
      </span>
      {children}
    </div>
  );
}

export function OptionCard({ selected, onClick, icon: Icon, label }: { selected: boolean; onClick: () => void; icon: LucideIcon; label: string }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex flex-col items-center gap-1.5 rounded-[11px] border-[1.5px] px-2.5 py-3 text-xs font-semibold text-center transition-colors ${
        selected ? "border-brand-blue bg-status-blue-bg text-brand-blue-dark" : "border-border text-ink-muted hover:border-brand-blue"
      }`}
    >
      <Icon size={19} />
      <span>{label}</span>
    </button>
  );
}
